import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { firstValueFrom, Observable, switchMap } from 'rxjs';
import { utils } from '../helper/utils';
import { UploadVesselWoFileResponse, VesselWoProcessingJob } from '../models/vessel-wo-processing-job.model';

interface VesselWoUploadTokenResponse {
  blobFileName: string;
}

@Injectable({
  providedIn: 'root',
})
export class VesselWoService {
  constructor(private readonly httpClient: HttpClient) {}

  uploadFile(maintenanceShopCode: string, file: File): Observable<UploadVesselWoFileResponse> {
    const uploadUrl = utils.GetBlobManagerAPIUrl('vessel-wo/files/upload');
    const uploadFormData = new FormData();
    uploadFormData.append('maintenanceShopCode', maintenanceShopCode);
    uploadFormData.append('file', file, file.name);

    return this.httpClient.post<VesselWoUploadTokenResponse>(uploadUrl, uploadFormData).pipe(
      switchMap((uploadToken) =>
        this.httpClient.post<UploadVesselWoFileResponse>(utils.GetOrderAPIUrl('maintenance-orders/vessel-wo/files'), {
          maintenanceShopCode,
          originalFileName: file.name,
          blobFileName: uploadToken.blobFileName,
          fileSizeBytes: file.size,
        }),
      ),
    );
  }

  getProcessingJobs(page: number, limit: number, shopCode?: string): Observable<HttpResponse<VesselWoProcessingJob[]>> {
    let params = new HttpParams().set('pageNumber', page).set('pageSize', limit);
    if (shopCode) {
      params = params.set('maintenanceShopCodes', shopCode);
    }
    return this.httpClient.get<VesselWoProcessingJob[]>(utils.GetOrderAPIUrl('maintenance-orders/vessel-wo/files'), {
      observe: 'response',
      params,
    });
  }

  async downloadReport(shopCode: string, reportBlobFileName: string, downloadedFileName: string): Promise<Blob> {
    const url = utils.GetBlobManagerAPIUrl(
      `vessel-wo/files/${encodeURIComponent(shopCode)}/${encodeURIComponent(reportBlobFileName)}/download`,
    );
    const blob = await firstValueFrom(this.httpClient.get(url, { responseType: 'blob' }));
    if (!blob) {
      throw new Error('Download failed');
    }
    return blob;
  }
}
